import { CircleDashed } from "@phosphor-icons/react";

import {
  DesktopFiltersDropdown,
  DesktopFiltersToolbar,
  DesktopFilterTag,
} from "features/filters/components";

import { DropdownMenuList } from "common/components/ui/DropdownMenu";

import {
  AUDIENCE_PROFILE_STATES,
  CANCELLED_TARGET_STATES,
} from "../../../../../constants";
import { AudienceStateFilterMenuContent } from "./AudienceStateFilterMenu";

import type {
  AudienceProfile,
  AudienceProfileState,
  CancelledTarget,
  CancelledTargetState,
} from "../../../../../types";

const STATE_FILTER = {
  state: {
    icon: <CircleDashed weight="fill" />,
    label: "State",
  },
} as const;

const audienceStateLabels = {
  ...CANCELLED_TARGET_STATES,
  ...Object.fromEntries(
    AUDIENCE_PROFILE_STATES.flatMap(({ label, states }) =>
      states.map((state) => [state, label]),
    ),
  ),
} as Record<AudienceProfileState | CancelledTargetState, string>;

interface AudienceDesktopFiltersProps {
  selectedStates: (AudienceProfileState | CancelledTargetState)[];
  setSelectedStates: (
    selectedGroups: (AudienceProfileState | CancelledTargetState)[],
  ) => void;
  audienceWithCancellation: (AudienceProfile & {
    cancellationDetails?: CancelledTarget;
  })[];
}

export default function AudienceDesktopFilters({
  selectedStates,
  setSelectedStates,
  audienceWithCancellation,
}: AudienceDesktopFiltersProps) {
  const clearAllFilters = selectedStates.length
    ? () => setSelectedStates([])
    : undefined;

  const filterMenuProps = {
    selectedStates,
    setSelectedStates,
    audienceWithCancellation,
  };

  const selectedStateFilterLabels = selectedStates.map(
    (state) => audienceStateLabels[state] ?? state,
  );

  return (
    <DesktopFiltersToolbar clearAllFilters={clearAllFilters}>
      {selectedStates.length > 0 && (
        <DesktopFilterTag
          icon={STATE_FILTER.state.icon}
          label={STATE_FILTER.state.label}
          selectedFilters={selectedStateFilterLabels}
          onRemove={() => setSelectedStates([])}
        >
          <DropdownMenuList>
            <AudienceStateFilterMenuContent {...filterMenuProps} />
          </DropdownMenuList>
        </DesktopFilterTag>
      )}

      <DesktopFiltersDropdown
        filters={STATE_FILTER}
        renderFilter={() => (
          <DropdownMenuList>
            <AudienceStateFilterMenuContent {...filterMenuProps} />
          </DropdownMenuList>
        )}
        hasFilters={!!clearAllFilters}
      />
    </DesktopFiltersToolbar>
  );
}
